export default "__VITE_ASSET__9Tdt_x82__"